import { z } from "zod";

export const zLinkView = z.object({
  view: z.literal("LinkView"),
});

export type ZLinkView = z.infer<typeof zLinkView>;
